<h3 class="font-extrabold mb-6">Send message to {{ data.workerName }}</h3>

<form [formGroup]="smsForm" class="overflow-x-hidden">
	<div class="grid">
		<div>
			<app-dropdown
				*ngIf="data.unionOptions?.length > 1"
				[placeholder]="'Select Union'"
				[formControl]="smsForm.get('unionId')"
				[label]="'Union'"
				[fullWidth]="true"
				[options]="data.unionOptions">
			</app-dropdown>
		</div>

		<label class="mt-2">
      Message*
      <textarea
        formControlName="comments"
        cols="65"
        rows="1"
        placeholder="Type Message"
        class="w-full border-2 rounded text-gray-600 p-4">
      </textarea>
		</label>
	</div>
	<app-dialog-footer 
		[valid]="smsForm.valid"
		[isSaving]="loading"
		[submitActionName]="'Confirm'"
		(cancelAction)="close()"
		(submitAction)="confirm()">
	</app-dialog-footer>
</form>